import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from 'antd'
import PerFlexRow from '../../components/custom_components/FlexRow'
import PerButton from '../../components/custom_components/Button'
import PerText from '../../components/custom_components/Text'
import PerButtonCircle from '../../components/custom_components/ButtonCircle'
import { CompanyRankingSettingsDto, Country, EmployeeAndTag, EmployeeTagType } from '../../types'
import { RankingTopTagConfirmationModalFooter } from './RankingTopTagConfirmationModalFooter'

export interface IRankingTopTagConfirmationButtonProps {
  employeeAndTags: EmployeeAndTag[]
  companySettings: CompanyRankingSettingsDto
  companyId: string
  country: Country
  setTopTagConfirmation: (value: boolean) => void
}

export const RankingTopTagConfirmationButton: FC<IRankingTopTagConfirmationButtonProps> = ({
  employeeAndTags,
  companySettings,
  companyId,
  country,
  setTopTagConfirmation,
}) => {
  const { t } = useTranslation()

  const [showModal, toggleModal] = useState<boolean>(false)

  const topTagCount = employeeAndTags.filter((o) => o.tags.some((tag) => tag.type === EmployeeTagType.Top)).length

  const canConfirmTopTags =
    !!companySettings.tagAssignmentIsInProgress &&
    topTagCount > 0 &&
    topTagCount <= Math.max(1, Math.round(employeeAndTags.length * (companySettings.topPercentage / 100) || 0))

  return (
    <>
      <PerFlexRow align="middle" justify="end" mt="xs" mb="xs">
        <PerButton
          text={t('global.button.confirm')}
          color="success"
          before="check_stroke"
          type="button"
          disabled={!canConfirmTopTags}
          onClick={() => toggleModal(true)}
          data-testid="ttc-modal-open"
        />
      </PerFlexRow>
      <Modal
        title={
          <PerFlexRow align="middle" justify="space-between">
            <PerText fontSize="xl" color="primary">
              {t('rankingView.modalTopTagConfirmation.header')}
            </PerText>
            <PerButtonCircle
              size="large"
              icon="close_stroke"
              color="transparent"
              onClick={() => toggleModal(false)}
              testid="ttc-modal-close"
            />
          </PerFlexRow>
        }
        visible={showModal}
        closable={false}
        bodyStyle={{ overflowY: 'auto', paddingBottom: '5px' }}
        footer={
          <RankingTopTagConfirmationModalFooter
            companyId={companyId}
            country={country}
            toggleModal={toggleModal}
            setTopTagConfirmation={setTopTagConfirmation}
          />
        }
        destroyOnClose={true}
        className="per-modal per-modal--large"
      >
        <PerText>{t('rankingView.modalTopTagConfirmation.description')}</PerText>
        <PerText mt="m">{t('rankingView.modalTopTagConfirmation.confirmation')}</PerText>
      </Modal>
    </>
  )
}
